// First-line client-side slur filter. See notes in original safety.js —
// server-side moderation is still required; this is UX-fast feedback only.

const PARTS = [
  ['ni','gger'], ['ni','gga'], ['ch','ink'], ['go','ok'],
  ['sp','ic'], ['wet','back'], ['ki','ke'],
  ['beane','r'], ['ra','ghead'], ['sand','nigger'],
  ['tow','elhead'], ['jig','aboo'], ['coo','n'],
  ['fa','ggot'], ['fa','g'], ['dy','ke'], ['tr','anny'],
  ['shem','ale'],
  ['ret','ard'], ['ret','arded'], ['mong','oloid'], ['spa','stic'],
  ['cu','nt'],
  ['hy','mie'],
  ['sl','ope'], ['ni','p'],
  ['gy','p'], ['gy','ppo'],
];
const SLURS = PARTS.map(p => p.join('').toLowerCase());

function normalize(s) {
  if (!s) return '';
  let t = s.toLowerCase();
  t = t.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  t = t.replace(/[\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/g, '');
  const leet = {
    '0':'o','1':'i','3':'e','4':'a','5':'s','6':'g','7':'t','8':'b','9':'g',
    '@':'a','$':'s','!':'i','|':'l','€':'e','£':'l','+':'t',
  };
  t = t.replace(/[013456789@$!|€£+]/g, c => leet[c] || c);
  return t;
}

function buildSearchForms(s) {
  const base = normalize(s);
  const stripped = base.replace(/[^a-z]/g, '');
  const collapsed = stripped.replace(/([a-z])\1+/g, '$1');
  return [base, stripped, collapsed];
}

const WORD_REGEXES = SLURS.map(w => new RegExp('\\b' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i'));

export function containsSlur(input) {
  if (!input || typeof input !== 'string') return false;
  const forms = buildSearchForms(input);
  for (const re of WORD_REGEXES) if (re.test(forms[0])) return true;
  for (const slur of SLURS) {
    if (forms[1].includes(slur)) return true;
    if (forms[2].includes(slur)) return true;
    const collapsedSlur = slur.replace(/([a-z])\1+/g, '$1');
    if (collapsedSlur.length >= 4 && forms[2].includes(collapsedSlur)) return true;
  }
  return false;
}

export const BLOCKED_MESSAGE = "We don't store that kind of language here. Try rephrasing.";
